<template>
  <div>
    <br />
    <div class="container-fluid" style="height: 800px">
      <h2 class="table-name" style="margin-bottom: 0">
        {{ this.configuration.page_title }}
      </h2>
       <div class="console well" v-if="toggleEditHistory">
          <span v-for="(item) in editMessages">
        <span style="display: block; font-size: 12px" v-html="item"></span>
       
        </span>
      </div>
      <div
        class="btn-group text-center"
        style="margin-top: 10px; margin-bottom: 10px"
      >
        <button
          class="btn btn-primary btn-hide"
          style="width: 150px"
          v-if="!showSearch"
          v-on:click="toggleSearch"
        >
          <i class="fa fa-search" style="font-size: 16px"></i>
          Search
          <span v-if="activeQuery && !searchError" class="badge">Active</span>
          <span v-if="activeQuery && searchError" class="badge badge-error"
            >Error</span
          >
        </button>
        <button
          class="btn btn-default btn-hide"
          style="width: 80px"
          v-if="showSearch"
          v-on:click="toggleSearch"
        >
          Hide
        </button>
      </div>

      <div v-if="showSearch">
        <div class="checkbox">
          <label>
            <input type="checkbox" v-on:change="depthLevel" />
            Complex Search
          </label>
        </div>
        <vue-query-builder
          :rules="rules"
          :maxDepth="depth"
          :labels="labels"
          :styled="true"
          v-model="query"
        ></vue-query-builder>

        <div style="display: block; margin-top: 20px">
          <div class="btn-group text-center">
            <button
              class="btn btn-default btn-hide btn-share"
              v-on:click="doFormatUrl"
            >
              Share Url
            </button>
            <button
              class="btn btn-primary btn-hide btn-search"
              v-on:click="doSearch"
            >
              Search
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <br />
      <div v-if="searchError">
        <p>There is an error in your search criteria.</p>
        <p>
          This can occur for example if you attempt to search an ID field with
          text that is supposed to be numeric.
        </p>
        <p>Please check the search and try again.</p>
      </div>
      <div v-if="countReturned">
          <p>This is record {{this.offsetplus1}} of {{this.countReturned}}</p>
        </div>
      <div class="modal-body">
        <div class="top-table-head">
          <div class="table-name1">
            {{ this.configuration.heading_table_1 }}
            <div class="btn-group">
              <button
                class="btn btn-primary btn-next"
                style="width: 80px"
                v-on:click="changePageBack"
                 :disabled = "prevDisabled"
              >
                Previous
              </button>
              <button 
              class="btn btn-primary btn-next"
              style="width: 80px"
              v-on:click="changePage"
              :disabled = "nextDisabled"
            >
              Next
            </button>
            <button
             class="btn btn-primary btn-next" 
             style="width: 80px" 
             v-on:click="toggleLog">
            <i class="fa fa-edit" style="font-size: 16px"></i> {{toggleEditHistory ? 'Hide Log' : 'Show Log'}}
          </button>
            
             <a v-if="this.configuration.display_table_links == true" :href = this.parent_link  target="_blank" class="btn btn-primary btn-next " ><i class="fa fa-link"></i> {{this.configuration.link_button_1}}</a>
             <a v-if="this.configuration.display_table_links == true" :href=  this.child_link  target="_blank"  class="btn btn-primary "><i class="fa fa-link"></i> {{this.configuration.link_button_2}}</a>
           
            </div>
          </div>
          <div v-if= "configuration.workflow1 == 'certified_workflow'" style="display: inline">
            <label for="certified_workflow" style="margin-bottom: 15px"
              >Workflow</label
            >
            <select
              v-on:change="setWorkflowParent"
              v-model="workflowParent"
              class="form-control sortBy workflowParent"
              id="certified_workflow"
            >
              <option :value="'election_night'">Election night</option>
              <option :value="' '">Certification</option>
            </select>
          </div>
        </div>
        <div id="example1">
          <hot-table
            class="example"
            :settings="settings"
            :data="table1Data"
            :columns="columnMetaData"
            :undo="undo"
             ref="parent"
          ></hot-table>
        </div>
        <hr />
        <div class="table-name1">{{ this.configuration.heading_table_2 }}</div>
        <div class="search-options">
          <div style="display: inline">
            <label for="child_order_by" style="margin-bottom: 15px"
              >Sort Column</label
            >
            <select
              v-on:change="setChildOrderBy"
              v-model="child_order_by"
              class="form-control orderBy"
              id="orderBy"
            >
              <option v-for="col in child_order_by_filters" :value="col.value">
                {{ col.label }}
              </option>
            </select>
          </div>
          <div style="display: inline">
            <label for="child_sort_direction" style="margin-bottom: 15px"
              >Sort Direction</label
            >
            <select
              v-on:change="setChildSortDirection"
              v-model="child_sort_direction"
              class="form-control sortBy"
              id="sortDirection"
            >
              <option :value="''">None</option>
              <option :value="'desc'">Descending</option>
              <option :value="'asc'">Ascending</option>
            </select>
          </div>
          <div v-if= "configuration.workflow2 == 'csr_workflow'" style="display: inline">
            <label for="csr_workflow" style="margin-bottom: 15px"
              >Workflow</label
            >
            <select
              v-on:change="setWorkflow"
              v-model="workflow"
              class="form-control sortBy workflow"
              id="csr_workflow"
            >
              <option :value="''">All</option>
              <option :value="'election_night'">Election night</option>
              <option :value="'recall_retention_election_night'">Recall/retention election night</option>
              <option :value="'rcv_election_night'">RCV election night</option>
            </select>
          </div>
        </div>
        <div id="example2">
          <hot-table
            class="example"
            :settings="settings2"
            :data="table2Data"
            :columns="columnMetaData2"
            :undo="undo"
            ref="child"
          ></hot-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
import "handsontable/dist/handsontable.full.css";
import VueQueryBuilder from "vue-query-builder";
import getFiltersForSearch from "../mixins/filtersForSearch.js";
import getOrderByFilters from "../mixins/getOrderByFilters.js";
import getColumnMetaData from "../mixins/columnMetaData.js";
import getPageDisclaimer from "../mixins/pageDisclaimers.js";
import getMultiTableConfig from "../mixins/multiTableConfig.js"
import hideColumnsMixin from "../mixins/hideColumns.js";
import validator from "../../node_modules/@bp_api4/schema_validation/index.js";
import { getTableConfigs } from '../mixins/schemaCache';
import { registerAllModules } from 'handsontable/registry';
registerAllModules();

// register Handsontable's modules
export default {
  name: "MultiTable",

  data: function () {
    return {
      configuration:{},
      columnMetaData: [],
      columnMetaData2: [],
      table1Data: [],
      table2Data: [],
      showSearch: false,
      activeQuery: false,
      table: null,
      rules: null,
      child_rules: null,
      depth: 1,
      offset: 0,
      offsetplus1 : 1,
      limit: 1,
      countReturned: false,
      nextDisabled: false,
      prevDisabled: true,
      loading: false,
      name: this.$route.params.name,
      workflow: "",
      workflowParent: " ",
      sortDirection: " ",
      orderBy: '',
      parent_link:'',
      child_link:'',
      child_order_by : '',
      child_order_by_filters: [],
      child_sort_direction : '',
      searchError: false,
      toggleEditHistory: false,
      editMessages: [],
      isPasting: false,
      undo: '',
      labels: {
        matchType: "Match Type",
        matchTypes: [
          { id: "all", label: "All of the filters" },
          { id: "any", label: "Any of the filters" },
        ],
        addRule: "Add Filter",
      },
      query: null,
      settings: {
        startRows: 1,
        undo: this.getMultiTableConfig(this.$route.params.name).undo,
        licenseKey: "non-commercial-and-evaluation",
        maxRows: 1,
        comments: true,
        manualColumnMove: true,
        manualColumnResize: true,
        rowHeights: 70,
        className: 'htMiddle',
        preventOverflow: "horizontal",
        afterChange: (changes) => {
          if (changes) {
              this.doParentChanges(changes)
          }
        },
        beforePaste: (data, coords) => {
           this.isPasting = true;
        },
        afterPaste: async (data, coords) =>{
          this.isPasting = false;
        },
        afterSelection: async (row, col, row2, col2) => {
          // if a table has hidden columns from a workflow you cannot select multiple columns for cut and paste or drag and drop
          // Get hidden columns
          let  hiddenColumns =  this.$refs['parent'].hotInstance.getSettings().hiddenColumns
          if (!hiddenColumns || !hiddenColumns.columns) {
            return;
          }
          
          let isAnyHiddenColumnInSelection = false;
          for (let i = col; i <= col2; i++) {
            if (hiddenColumns.columns.includes(i)) {
                isAnyHiddenColumnInSelection = true;
                break;
            }
          }
          if (col2 && col2 != col && isAnyHiddenColumnInSelection && !this.isPasting) {
            window.alert('Selection in workflow contains hidden columns.');
            this.$refs['parent'].hotInstance.deselectCell();
          }
        },
      },
      settings2: {
        startRows: 1,
        undo: this.getMultiTableConfig(this.$route.params.name).undo,
        licenseKey: "non-commercial-and-evaluation",
        comments: true,
        manualColumnMove: true,
        manualColumnResize: true,
        rowHeights: 50,
        className: 'htMiddle',
        currentRowClassName: 'currentRow',
        isPasting:false,
        afterChange: (changes) => {
          if (changes) {
              this.doChildChanges(changes)
          }
        },
        beforePaste: (data, coords) => {
           this.isPasting = true;
        },
        afterPaste: async (data, coords) =>{
          this.isPasting = false;
        },
        afterSelection: async (row, col, row2, col2) => {
          // if a table has hidden columns from a workflow you cannot select multiple columns for cut and paste or drag and drop
          // Get hidden columns
          let  hiddenColumns =  this.$refs['child'].hotInstance.getSettings().hiddenColumns
          if (!hiddenColumns || !hiddenColumns.columns){
            return;
          }
          
          let isAnyHiddenColumnInSelection = false;
          for (let i = col; i <= col2; i++) {
            if (hiddenColumns.columns.includes(i)) {
                isAnyHiddenColumnInSelection = true;
                break;
            }
          }    
          if (col2 && col2 != col && isAnyHiddenColumnInSelection && !this.isPasting ){
            window.alert('Selection in workflow contains hidden columns.');
            this.$refs['child'].hotInstance.deselectCell();
          }
        },
      }
    };
  },

  components: {
    HotTable,
    VueQueryBuilder,
  },

  mixins: [
    getOrderByFilters,
    getFiltersForSearch,
    getColumnMetaData,
    getPageDisclaimer,
    getMultiTableConfig,
    hideColumnsMixin
  ],
 
  methods: {
    setWorkflow() {
      const hiddenColumnNamesByWorkflow = {
        election_night: ['Votes Against', 'RCV Round'],
        recall_retention_election_night: ['RCV Round'],
        rcv_election_night: []
      };

      if (this.workflow in hiddenColumnNamesByWorkflow) {
        this.$refs.child.hotInstance.updateSettings({
          hiddenColumns: {columns: this.hiddenColumnIndexesForNames(hiddenColumnNamesByWorkflow[this.workflow], this.columnMetaData2),
          copyPasteEnabled: false
          }
        });
      } else {
        this.$refs.child.hotInstance.updateSettings({
          hiddenColumns: {columns: this.hiddenColumns,
                          copyPasteEnabled: false
          }
        });
        this.workflow = '';
        
      }
    },


    setWorkflowParent() {
      const columnsToHide = this.workflowParent === 'election_night'
        ? this.hiddenColumnIndexesForNames(['Results Certified'])
        : [];

      this.$refs.parent.hotInstance.updateSettings({
        hiddenColumns: {columns: columnsToHide,
                        copyPasteEnabled: false
        }
      });
    },


    setChildOrderBy() {
      this.child_order_by = event.target.value;
      if (this.child_order_by == null){
        this.child_order_by == 'updated'
      }
     
      this.getFilteredData();
    },


    setChildSortDirection() {
      this.child_sort_direction = event.target.value;
      this.getFilteredData();
    },


    toggleSearch() {
      this.showSearch = !this.showSearch;
    },


    toggleLog() {
      this.toggleEditHistory = !this.toggleEditHistory;
    },


    changePage() {
      if (this.offsetplus1 < this.countReturned || this.countReturned == false) { 
         this.offset = this.offset + 1;
         this.offsetplus1 = this.offsetplus1 + 1;
         this.prevDisabled = false;
      }
      if (this.offsetplus1 <= this.countReturned || this.countReturned == false ) {
          this.getFilteredData();
      }
      if (this.offsetplus1 == this.countReturned) {
        this.nextDisabled = true
      } else {
        this.nextDisabled = false
      }
    },


    changePageBack() {
      if (this.offset > 0){
          this.offset = this.offset -1;
          this.offsetplus1 = this.offsetplus1 - 1;
          this.getFilteredData();
      }
      if (this.offset == 0) {
          this.prevDisabled = true
          this.nextDisabled = false
      } else {
        this.prevDisabled = false
      }
      if (this.offsetplus1 == this.countReturned){
          this.nextDisabled = true
      } else {
          this.nextDisabled = false
      }
    },


    depthLevel() {
      this.depth = this.depth === 3 ? 1 : 3;
    },


    doSearch() {
      this.searchError = false;
      this.showSearch = false; // Hide search after click
      this.offset = 0;
      this.offsetplus1 = 1;
      this.countReturned = false;
      this.getFilteredData(true);
      this.getFilteredData(false);
      this.prevDisabled = true;
      this.nextDisabled = false  
    },


    doFormatUrl() {
      const query = {};
      query.where = this.query;
      query.table = this.table;
      query.limit = this.limit;
      query.offset = this.offset;
      query.orderBy = this.orderBy;
      query.workflowParent = this.workflowParent ? this.workflowParent : "''";
      query.workflow = this.workflow ? this.workflow : null;
      
      let filterUrl;
      if (this.query === null) {
        filterUrl = `${window.location.href.split("?")[0]}`;
      } else {
        filterUrl = `${window.location.href.split("?")[0]}?${encodeURIComponent(JSON.stringify(query))}`;
      }
      let textArea = document.createElement("textarea");
      textArea.value = filterUrl;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        window.alert("Sharable URL copied to clipboard");
      } catch (err) {
        //empty
      }
      document.body.removeChild(textArea);
    },


    formatUrlLink(related_id,parent, child, related_field) {
      let parent_query = {}
      let child_query = {}
      parent_query.table = parent;
      child_query.table = child;
     
      child_query =  `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"${child}_view.${related_field}->>'id'","selectedOperator":"equal","selectedOperand":"Stage ID","value":"${related_id}"}}]},"table":"${child}","limit":25,"offset":1,"orderBy":null,"isCountOnly":false}`  
      child_query = encodeURIComponent(child_query)
      parent_query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"${parent}_view.id","selectedOperator":"equal","selectedOperand":"ID","value":"${related_id}"}}]},"table":"${parent}","limit":25,"offset":1,"orderBy":null,"isCountOnly":false}`  
      parent_query = encodeURIComponent(parent_query)
      this.child_link = `${window.location.origin}/tables/${child}?${child_query}`;
      this.parent_link = `${window.location.origin}/tables/${parent}?${parent_query}`;
    },


    async getFilteredData(count_only = false) {
      let query = {};

      query.where = this.query;
      query.table = this.table;
      query.table = this.configuration.table1
      query.limit = 1;
      query.workflow = this.workflow ? this.workflow : null;
      query.offset = this.offsetplus1;
      query.orderBy = this.orderBy
        ? `${this.orderBy} ${this.sortDirection}`
        : null;
      query.isCountOnly = count_only;
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      if (query.where && query.where.children) {
        this.activeQuery = true;
        // If user removes search criteria, null the WHERE clause.
        if (query.where.children.length === 0) {
          query.where = null;
          this.activeQuery = false;
        }
      }

      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;
      
      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(query),
        }
      );
      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON
        
        if (response.success === true) {
          this.clearErrorCommentsAll('parent');
          this.clearErrorCommentsAll('child')
          if (count_only == false){
            this.table1Data.splice(0, this.table1Data.length);
            this.table2Data.splice(0, this.table2Data.length);
            response.data.forEach((item) => {
                item["columnselected"] = false;
                this.table1Data.push(item);
            });
          }
          if (count_only == true && response.data && response.data[0] && response.data[0].count) {
            this.countReturned = response.data[0].count;
            if (this.countReturned == 1 || this.countReturned == 0){
               this.nextDisabled = true;
            }
          } 
          if (count_only == false) {
            await this.getChildrenData(this.table1Data[0][`${this.configuration.related_field_table_1}`]);
            if (this.configuration.display_table_links == true) {
              this.formatUrlLink(this.table1Data[0][`${this.configuration.related_field_table_1}`],this.configuration.link_table_1,this.configuration.link_table_2,this.configuration.link_field) 
            }
          }
        } else  {
          this.resultMessage = "Error getting filtered data";
          this.visible = true;
          this.searchError = true;
          console.log("ERROR IN FILTERED DATA RESPONSE");
        }
        this.setWorkflow();
        this.setWorkflowParent();
      }
    },


    clearErrorCommentsAll(ref) {
      const hot = this.$refs[ref].hotInstance;  // Get the Handsontable instance
      // Get the number of rows and columns in the table
      const numRows = hot.countRows();
      const numCols = hot.countCols();

      // Loop through all cells in the table and clear their comments
      for (let row = 0; row < numRows; row++) {
        for (let col = 0; col < numCols; col++) {
          hot.setCellMeta(row, col, 'comment', null);  // Remove the comment
          hot.setCellMeta(row, col, "valid", true);
        }
      }

      // Re-render the table to apply changes
      hot.render();
    },


    async getChildrenData(related_id) { 
      let query = {};
      query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"${this.configuration.related_field_variable}","selectedOperator":"equal","selectedOperand":"${this.configuration.related_field_name}","value":"${related_id}"}}]},"table":"${this.configuration.table2}","orderBy":"${this.child_order_by} ${this.child_sort_direction}","limit":100}`;
      
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: query,
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON

        if (response.success === true) {
          this.table2Data.splice(0, this.table2Data.length);
          response.data.forEach((item) => {
            item["columnselected"] = false;
            this.table2Data.push(item);
          });
        } else {
          this.resultMessage = "Error getting filtered data";
          this.visible = true;
          console.log("ERROR IN FILTERED DATA RESPONSE");
        }
      }
    },
    

    async doChildChanges(changes) {
      await this.doChanges(changes,'child')
    },


    async doParentChanges(changes) {
       await this.doChanges(changes, 'parent')
    },


    //  beforeUndo: async (action) => {
    //    if (this.configuration.undo == false){

    //    }
    //  },


    updateErrorValue(row, col, message, ref) {
      const commentsPlugin = this.$refs[ref].hotInstance.getPlugin("comments");
       commentsPlugin.setCommentAtCell(row, col, message);
       this.$refs[ref].hotInstance.setCellMeta(row, col, "valid", false);
       this.$refs[ref].hotInstance.render();
    },


    clearErrorValue(row, column,ref) {
      const commentsPlugin = this.$refs[ref].hotInstance.getPlugin("comments");
      let comment = commentsPlugin.getCommentAtCell(row, column);
      if (comment) {
        commentsPlugin.removeCommentAtCell(row, column);
          this.$refs[ref].hotInstance.setCellMeta(row, column, "valid", true);
          this.$refs[ref].hotInstance.render();
      }
    },


    async doInsert(change,rowData, updateInfo, ref ) {
      if (change[3] == null  || (change[3]).trim().length == 0  ) {  // not creating a record to insert a null value.
        return;
      }
      let changeCol = this.$refs[ref].hotInstance.propToCol(change[1]);                   
      let dataObject = {};
      let validate;
      for (let item in this.configuration.insert_fields.required_fields){
          dataObject[this.configuration.insert_fields.required_fields[item]['name']] =
          this.configuration.insert_fields.required_fields[item]['type'] == "int" ? parseInt(rowData[this.configuration.insert_fields.required_fields[item]['name']]) : rowData[this.configuration.insert_fields.required_fields[item]['name']]
      } 
          
      let payload = {
          data: [dataObject],
          table: this.configuration.insert_fields.table
      };
      
      try {
        const tableConfigs = await getTableConfigs([payload.table]);
        const validationSchema = { data: { api4Tables: { tables: Object.values(tableConfigs) } } };
        validate = await validator.validatePayload(
          payload,
          validationSchema,
          "POST"
        );
        //let validate = null; // for testing -- remove line after production.
      } catch (e) {
        console.log(e); // TO Do:   Display this error message somewhere indicating that the problem is severe and tech should be contacted.
        return;
      }
      // Parse error, show warning modal
      if (validate && Object.entries(validate.errors).length !== 0) {
        let message = this.parseFrontendError(validate);
        this.updateErrorValue(
          this.$refs[ref].hotInstance.toVisualRow(change[0]),
          changeCol,
          message,ref
        );
        return;
      } else {
        let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/insertOne`;
        let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: "POST",
          headers: headers,
          credentials: 'include',
          body: JSON.stringify(payload)
        });
        if (response.status == 403) {
          response = await response.json();
          alert(response.message);
          window.location.href = "/login";
        } else {
          response = await response.json();
          if (response.success === false) {
            this.updateErrorValue(
              this.$refs[ref].hotInstance.toVisualRow(change[0]),
              changeCol,
              JSON.parse(response.message).message,ref
            );
          } else {
            let newId = Number(response.data.id);
            this.$refs[ref].hotInstance.setDataAtCell(change[0], this.$refs[ref].hotInstance.propToCol(this.configuration.insert_fields.key_field), newId);
            this.showChangeNotificationInsert(newId,this.configuration.insert_fields.table)
            // this.$refs[ref].hotInstance.setCellMeta(change[0], this.$refs[ref].hotInstance.propToCol(this.configuration.insert_fields.key_field), 'className', 'success');
            //this.$refs.hot.$refs.hot.hotInstance.render();
          }
        }
      }
    },


    async doChanges(changes, ref) {
      // This function is called whenever a cell is touched and then navigated away from.
      if (changes) {
        for await (const change of changes) {
          if (
            change == null ||
            change[1] === "columnselected" ||
            change[1] === "id"
          ) {
            // The function also fires when the table first loads and returns null, check null and kill function.
            continue;
          } else {
            const rowData = this.$refs[ref].hotInstance.getSourceDataAtRow(
              change[0]
            );
            let dataType = this.$refs[ref].hotInstance.getCellMeta(
              change[0],
              this.$refs[ref].hotInstance.propToCol(change[1])
            ).__proto__.dataType;
            let id = Number(rowData.id); // Get row ID and convert to number
            let columnName = change[1]; // Get column name of changed value

            if (columnName.includes(".id")) {
              columnName = columnName.substring(0, columnName.length - 3); // this means we are dealing with a related table.  We just want the related table name without the id
            }

            let currentValue = change[2]; // Value of cell before change
            let changeCol = this.$refs[ref].hotInstance.propToCol(change[1]);
            
            this.clearErrorValue(
              this.$refs[ref].hotInstance.toVisualRow(change[0]),
              changeCol, ref
            );

            const columnMetaData = this.$refs[ref].hotInstance.getCellMeta(
              change[0],
              this.$refs[ref].hotInstance.propToCol(change[1])
            ).__proto__;
            let updatedValue = this.formatUpdatedValue(change[3], dataType);
            if (currentValue === change[3] || currentValue === updatedValue) {
              // no change so no need for a database call
              continue;
            } else {
              //  Create the payload
              //console.log('Creating payload')
              let dataObject = {};
              let payload;
              
              // custom workflow --> check if we need to update another table
              if (columnMetaData.workflowUpdates) {
                // no updates needed
                if (columnMetaData.workflowUpdates.length === 0) {
                  return;
                }
                for (let updateInfo of columnMetaData.workflowUpdates) {
                  // ID is null --> this is an insert and not an update. do insert
                  if (!rowData[updateInfo.id]) {
                       this.doInsert(change, rowData,updateInfo, ref)
                       return;
                  }

                  dataObject.id = Number(rowData[updateInfo.id]);
                  dataObject[updateInfo.column] = updatedValue;
                  payload = {
                    data: [dataObject],
                    table: updateInfo.table,
                  };
                }
              } 
              
              // Validate on the front end
              let validate;

              try {
                const tableConfigs = await getTableConfigs([payload.table]);
                const validationSchema = { data: { api4Tables: { tables: Object.values(tableConfigs) } } };
                validate = await validator.validatePayload(
                  payload,
                  validationSchema,
                  "PATCH"
                );
                //let validate = null; // for testing -- remove line after production.
              } catch (e) {
                console.log(e); // TO Do:   Display this error message somewhere indicating that the problem is severe and tech should be contacted.
                continue;
              }
              // Parse error, show warning modal
              if (validate && Object.entries(validate.errors).length !== 0) {
                let message = this.parseFrontendError(validate);
                this.updateErrorValue(
                  this.$refs[ref].hotInstance.toVisualRow(change[0]),
                  changeCol,
                  message,ref
                );
                continue;
              } else {
                // If no frontend errors, hit API, update DB
                let headers = {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                };
                headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud`;

                let response = await fetch(
                  `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
                  {
                    method: "PATCH",
                    headers: headers,
                    credentials: "include",
                    body: JSON.stringify(payload),
                  }
                );
                if (response.status == 403) {
                  response = await response.json();
                  alert(response.message);
                  window.location.href = "/login";
                } else {
                  response = await response.json();
                  if (response.success === false) {
                    this.updateErrorValue(
                      this.$refs[ref].hotInstance.toVisualRow(change[0]),
                      changeCol,
                      JSON.parse(response.message).message,ref
                    );
                    continue;
                  } else {
                    // custom workflows: display table and ID that was updated
                    if (columnMetaData.workflowUpdates) {
                      for (let updateInfo of columnMetaData.workflowUpdates) {
                        this.showChangeNotification(
                          rowData[updateInfo.id],
                          updateInfo.column,
                          currentValue,
                          updatedValue,
                          updateInfo.table
                        );
                      }
                    } else {
                      this.showChangeNotification(
                        id,
                        columnName,
                        currentValue,
                        updatedValue
                      );
                    }

                    console.log("Database updated");
                  }
                }
              }
            }
          }
        }
      }
    },


    parseFrontendError(validate) {
      let errorId = Number(Object.keys(validate.errors));
      let errCol = Object.keys(validate.errors[errorId]).toString();
      let errMsg = validate.errors[errorId][errCol].toString();
      return `Id: ${errorId} - ${errMsg}`;
    },


    formatUpdatedValue(updatedValue, dataType) {
      if (
        (dataType === "integer" && updatedValue != null) ||
        (dataType === "numeric" && updatedValue != null)
      ) {
        updatedValue = updatedValue.toString().replace(/,/g, "");
      }
      if (typeof updatedValue === "string") {
        updatedValue = updatedValue.trim(); // Value of cell after change
        updatedValue = updatedValue.length === 0 ? null : updatedValue;
      }

      if (dataType === "ARRAY" && updatedValue) {
        updatedValue = `{${updatedValue}}`;
      }

      if (
        updatedValue === "true" ||
        updatedValue === "false" ||
        (!isNaN(updatedValue) &&
          updatedValue != null &&
          updatedValue.length > 0 &&
          dataType !== "character varying" &&
          dataType !== "text")
      ) {
        updatedValue = JSON.parse(updatedValue);
      }
      updatedValue = updatedValue == null ? null : updatedValue;
      return updatedValue;
    },


    showChangeNotification(id, column, currentValue, updatedValue, table) {
      const advancedValues = ['Advanced - General', 'Advanced - Primary Runoff', 'Advanced - General Runoff'];
      let sentence;

      if (advancedValues.includes(updatedValue)) {
        sentence = `<b>${id}:</b> <i>${column}</i> changed from ${currentValue} to ${updatedValue} <br> A candidate stage result record was created for the ${updatedValue.split(' - ')[1]} stage.`;
      } else if (table) {
        sentence = `<b>${id} ${table}:</b> <i>${column}</i> changed`
        if (currentValue !== undefined) {
          sentence += ` from ${currentValue}`
        }
        if (updatedValue !== undefined) {
          sentence += ` to ${updatedValue}`;
        }
      } else {
        sentence = `<b>${id}:</b> <i>${column}</i> changed from ${currentValue} to ${updatedValue}`
      }

      // For Growl Notifications, but only show if edit history box is hidden.
      if(!this.toggleEditHistory) {
        this.$toastr.s(sentence)
      }
      // For log history box
      this.editMessages.unshift(sentence);
    },


    showChangeNotificationInsert(id, table){
      let sentence = `<b>${id}:</b> <i>inserted into ${table}`
       if(!this.toggleEditHistory) {
          this.$toastr.s(sentence)
        }
        this.editMessages.unshift(sentence)
    }

  },

  mounted: async function () {
    this.configuration = await this.getMultiTableConfig(this.name)
      
    this.child_order_by = this.configuration.orderBy2
    this.orderBy = this.configuration.orderBy1
    this.child_sort_direction = this.configuration.sortDirection2
    this.sortDirection = this.configuration.sortDirection1
    this.table = this.configuration.table1;
    this.rules = await this.generateFiltersForSearch();
    this.orderByFilters = await this.getOrderByFilters(this.rules);
    this.table = this.configuration.table2;
    this.child_rules = await this.generateFiltersForSearch()
    this.child_order_by_filters = await this.getOrderByFilters(this.child_rules)
    this.undo = this.configuration.undo
    await this.generateColumnMetaData(
        "Edit",
        this.configuration.table2
    );
      
    this.columnMetaData2 = [...this.columnMetaData];
    this.columnMetaData = [];
    this.table = this.configuration.table1;
    await this.generateColumnMetaData("Multi", this.configuration.table1);
    if (window.location.href.indexOf("where") > -1) {
      let query = JSON.parse(
        JSON.stringify(decodeURIComponent(window.location.href ? window.location.href.split("?")[1] : window.location.search.slice(1)))
      );
      this.query = JSON.parse(query).where;
      this.limit = JSON.parse(query).limit;
      this.offset = JSON.parse(query).offset;
      this.workflow = JSON.parse(query).workflow;
      this.workflowParent = JSON.parse(query).workflowParent;
      this.showSearch = true;
      await this.getFilteredData();
      await this.getFilteredData(true)
      //this.setWorkflowParent()
    } else {
      if (this.configuration.workflow1 == 'certified_workflow'){
        this.workflowParent = '9';
      }
      await this.getFilteredData();
    } 
     
  },
};
</script>

<style scoped>
#example2 >>> .wtHolder::-webkit-scrollbar {
  display: none;
}
.console {
  position: absolute;
  right: 48px;
  top: 75px;
  width: 400px;
  height: 100px;
  overflow: scroll;
  display: flex;
  flex-direction: column-reverse;
}

.console hr {
  margin-top: 0;
  margin-bottom: 0;
}

.well {
  padding-bottom: 10px;
}
.page-select,
.record-number {
  width: 100px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.orderBy,
.sortBy {
  width: 120px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}
.container-fluid {
  margin-right: 5%;
  margin-left: 3%;
  margin-bottom: 10%;
}
.example {
  min-width: 800px;
}
#example1 {
  padding-top: 10px;
  font-weight: bold !important;
  font-size: 15px;
  text-align: center;
}

.table-name1 {
  text-align: left;
  font-size: large;
  font-weight: bold;
  margin-bottom: 15px;
}
.btn-next {
  min-width: 120px;
  margin-left: 10px;
}
.top-table-head {
  margin-bottom: 10px;
  margin-top: 10px;
}
/* Large rounded green border */
hr {
  border: 5px solid white;
  border-radius: 5px;
}
.badge-error {
  background-color: red;
  color: white;
}
</style>
